import React from 'react'
import './AdminFooter.css'

const AdminFooter = () => {
  return (
    <section className="adminFooterContent">
      <div className="footerText">
        ADMIN COPY OF TRAVEL.
      </div>
    </section>
  )
}

export default AdminFooter